import { cn } from "@/utils";
import { LoaderCircle } from "lucide-react";

export type LoaderProps = {
  className?: string;
  size?: "xxs" | "xs" | "sm" | "regular" | "lg" | "xl";
};

const sizeClasses = {
  xxs: "h-4 w-4",
  xs: "h-6 w-6",
  sm: "h-8 w-8",
  regular: "h-12 w-12",
  lg: "h-14 w-14",
  xl: "h-16 w-16",
};

export const Loader = ({ className, size = "regular" }: LoaderProps) => {
  return (
    <LoaderCircle className={cn("animate-spin text-blue-600", sizeClasses[size], className)} />
  );
};
